export default {
  tab: {
    index: 'Chỉ số',
    prospect: 'Các Thị Trường',
    valuation: 'Định Giá',
    liquidity: 'Thanh Khoản',
    marketAnomaly: 'Biến Động',
  },

  indexSummary: {
    totalVolume: 'Tổng KL: ',
    totalValue: 'Tổng GT: ',
    bnVnd: 'Tỷ VND',
  },
};
